import React from "react";

export const ShowText = ({ text, setShowText, mousePosition, key }) => {

  const handleCloseImage = (e) => {
    e.stopPropagation();
    setShowText(false);
  };

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000073] z-50 overflow-auto" onClick={handleCloseImage} key={key}>
      <div className="absolute bg-white rounded-lg py-[15px] px-[15px]" style={{ top: mousePosition.y, left: mousePosition.x }}>
        {text}
      </div>
    </div>
  );
};
